import { TimelineProps } from "./types";

const Timeline = ({ items }: TimelineProps) => {
  return (
    <div className="flex flex-col pl-4 py-2">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;

        return (
          <div key={item.id} className="relative flex gap-x-4 items-start pb-8 last:pb-0">
            
            {/* ==========================================
                LEFT COLUMN: Timeline Indicators & Lines
               ========================================== */}
            <div className="flex flex-col items-center h-full">
              {/* Node Ring Circle */}
              <div
                className={`w-5 h-5 rounded-full border-[3px] bg-white z-10 shrink-0 transition-colors ${
                  item.isActive 
                    ? "border-primary" // Active highlighted blue ring
                    : "border-slate-300" // Muted fallback gray ring
                }`}
              />
              
              {/* Connecting Vertical Line (Hidden for the last item) */}
              {!isLast && (
                <div className="absolute top-5 left-[9px] w-[2px] bottom-0 bg-slate-200 z-0" />
              )}
            </div>

            {/* ==========================================
                RIGHT COLUMN: Content Text Description 
               ========================================== */}
            <div className="flex flex-col">
              <h4 className="text-[14px] font-semibold text-slate-900 leading-snug">
                {item?.name || ""}
              </h4>
              <p className="text-[12px] font-medium text-slate-400 mt-0.5">
                {item?.desc || ""}
              </p>
            </div>

          </div>
        );
      })}
    </div>
  );
};

export default Timeline;